import axios from 'axios';
import { downloadBlob } from 'ca-js-helper';

const download = {
    methods: {
        doDownload(shortcode, type, url) {
            console.log('doDownloadQR', shortcode, type, url);
            axios
                .get(url, {responseType: 'blob'})
                .then(response => downloadBlob(response.data, `image/${type}`, `${shortcode}.${type}`));
        },
    },
};

export default download;
